module.exports = __webpack_public_path__ + "static/media/elastic-cloud.6d880500.svg";